import React, { useEffect, useState } from "react";
import { Star, StarFill } from "react-bootstrap-icons";
import "./styles.css";

const UseStarRating = ({
  field,
  register,
  setValue,
  disable = false,
  number = 5,
  size = "2em",
  watch,
  starClass,
  error,
}) => {
  const [hoverRating, setHoverRating] = useState(-1);
  const rating = watch(field);

  useEffect(() => {
    register(field);
  }, [field, register]);

  function handleClick(pos) {
    setValue(field, Number(pos + 1));
  }

  return (
    <div>
      <div className={`d-flex gap-5 ${starClass}`}>
        {!rating
          ? [...Array(Number(number))].map((_, idx) => (
              <Star
                size={size}
                className="star"
                key={idx}
                role="button"
                onClick={() => handleClick(idx)}
                onMouseEnter={() => setHoverRating(idx)}
                onMouseLeave={() => setHoverRating(-1)}
                fill={hoverRating >= idx ? "var(--primary-color)" : ""}
              />
            ))
          : [...Array(Number(number))].map((_, idx) => {
              if (rating >= idx + 1) {
                return (
                  <StarFill
                    size={size}
                    className="star"
                    key={idx}
                    role="button"
                    fill="var(--primary-color)"
                    onClick={() => handleClick(idx)}
                  />
                );
              } else {
                return (
                  <Star
                    size={size}
                    className="star"
                    key={idx}
                    role="button"
                    onClick={() => handleClick(idx)}
                    onMouseEnter={() => setHoverRating(idx)}
                    onMouseLeave={() => setHoverRating(-1)}
                    fill={hoverRating >= idx ? "var(--primary-color)" : ""}
                  />
                );
              }
            })}
      </div>
      {error && (
        <div className="d-block invalid-feedback flex-column">{error}</div>
      )}
    </div>
  );
};

export default UseStarRating;
